import { render } from "./PlusTopBar.vue?vue&type=template&id=3ae840a3"
import script from "./PlusTopBar.vue?vue&type=script&lang=js"
export * from "./PlusTopBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__